export default __webpack_public_path__ + "static/img_perfil-2135990ffc3f39a3fef636e2002b6975.png";